<template>
  <div class="wrapper">
    <Header class="header" data-title="전화상담신청" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="guideMsg">
            <p class="txtL">
              지금은 고객센터 운영시간이 아닙니다.
              <br />
              상담신청을 남겨주시면
              <br />
              웰몰 전문상담원이 상담해 드립니다.
            </p>
            <p class="txt">고객센터 운영시간은 평일 오전 9시~오후 6시 입니다.</p>
          </div>

          <div class="formArea">
            <span class="label">
              이름
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" />
            <span class="label">
              휴대폰번호
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input type="tel" id="phone_2" class="ipt" title="휴대폰 번호 입력" placeholder="' - ' 없이 입력해주세요." value="" />

            <!-- 약관 (s) -->
            <div class="termsWrap">
              <div class="inner">
                <ul class="iptGroup">
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="terms1" id="terms1_3" />
                      <label for="terms1_3">
                        <span>[필수]</span>
                        개인정보수집 및 이용약관 동의
                      </label>
                      <button type="button" class="links arrow"><span class="blind">상세약관 전체보기</span></button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 약관 (e) -->
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p">상담신청</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
//import * as customjs from '../../../../static/js/m.front.js';

export default {
  name: 'customerCenterCellCounseling',
  mounted() {
    //customjs.init();
  },
};
</script>
